import React from 'react';
import { Clock } from 'lucide-react';
import HRISListPage from '../HRISListPage';
import { getAttendance, createAttendance, updateAttendance, deleteAttendance, getEmployeeList } from '../hrisApi';

const STATUS_OPTIONS = ['Present', 'Absent', 'Half Day', 'On Leave', 'Work From Home'];
const SHIFT_OPTIONS = ['Morning (07:00-16:00)', 'Regular (08:00-17:00)', 'Afternoon (14:00-23:00)', 'Night (22:00-07:00)'];

const columns = [
  { key: 'employeeName', label: 'Employee' },
  { key: 'attendanceDate', label: 'Date' },
  { key: 'shift', label: 'Shift' },
  { key: 'inTime', label: 'In Time' },
  { key: 'outTime', label: 'Out Time' },
  { key: 'workingHours', label: 'Hours', render: (v) => v ? `${v}h` : '—' },
  { key: 'status', label: 'Status', badge: true },
];

const formFields = [
  { key: 'employeeName', label: 'Employee', type: 'select', required: true, optionsLoader: getEmployeeList },
  { key: 'attendanceDate', label: 'Attendance Date', type: 'date', required: true },
  { key: 'shift', label: 'Shift', type: 'select', options: SHIFT_OPTIONS },
  { key: 'inTime', label: 'In Time', type: 'time' },
  { key: 'outTime', label: 'Out Time', type: 'time' },
  { key: 'status', label: 'Status', type: 'select', required: true, options: STATUS_OPTIONS, defaultValue: 'Present' },
  { key: 'lateEntry', label: 'Late Entry (minutes)', type: 'number', placeholder: '0' },
  { key: 'earlyExit', label: 'Early Exit (minutes)', type: 'number', placeholder: '0' },
  { key: 'remarks', label: 'Remarks', type: 'textarea', placeholder: 'Any remarks...' },
];

const ShiftAttendance = () => (
  <HRISListPage
    title="Shift & Attendance"
    description="Track employee attendance records and shift assignments"
    icon={<Clock />}
    columns={columns}
    fetchData={getAttendance}
    createData={createAttendance}
    updateData={updateAttendance}
    deleteData={deleteAttendance}
    formFields={formFields}
    entityName="Attendance Record"
    searchPlaceholder="Search by employee or date..."
  />
);

export default ShiftAttendance;
